<template>
  <SeoBlogArticle :content="$t('seoArticleOQueEUtmSource')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleOQueEUtmSource',
  components: { SeoBlogArticle },
}
</script>
